<template>
  <header class="site-header">
    <div class="container">
      <div class="left">
        <button
          class="icon-button icon-arrow-back"
          @click="goBackClicked"
        ></button>
      </div>
      <div class="center">
        <h1>
          <span class="desktop-only"
            >{{
              $route.meta.sectionTitle !== $route.meta.mobileTitle
                ? $route.meta.sectionTitle
                : ""
            }} </span
          >{{ $route.meta.mobileTitle }}
        </h1>
      </div>
      <div class="right">
        <div class="header-person" v-if="$route.meta.profile_pic">
          <div class="text">
            <div class="name">{{ $route.meta.user_header_text }}</div>
          </div>
          <div class="avatar">
            <base-image :src="`${$route.meta.profile_pic}`" alt="user" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { AUTH_USER_GET } from "Public/store/modules/auth";
import { CATEGORIES_GET } from "Public/store/modules/categories";
import { NAV_SIDE_TOGGLE } from "Public/store/modules/nav";
import SideNav from "../components/SideNav/SideNav";
import { EventBus } from "Public/store/modules/eventbus";
import BaseImage from "Public/components/BaseImage";

export default {
  name: "TopNav",
  data() {
    return {
      open: false,
      mobileOpen: false,
      screen: "mobile",
    };
  },
  components: {
    BaseImage,
    SideNav,
  },
  methods: {
    ...mapActions({
      sideToggle: NAV_SIDE_TOGGLE,
    }),

    goBackClicked() {
      const { prevRoute } = this.$route.meta;
      if (prevRoute && prevRoute.fullPath.includes("temp")) {
        this.$router.go(-2);
      } else {
        this.$router.go(-1);
      }
    },
    dropdown() {
      this.open = !this.open;
      this.mobileOpen = !this.mobileOpen;
    },

    openMenu() {
      let wrapper = document.getElementById("wrapper");

      if (!this.open && window.screen.width > 768) {
        wrapper.style = "margin-left: 209px;";
      } else {
        wrapper.style = "margin-left: 0;";
      }

      this.open = !this.open;
    },

    profilePic(user, size) {
      return this.$util.img.profilePictureBubble(
        user.profile_pic ? user.profile_pic.file_url : null,
        size
      );
    },

    back() {
      window.history.go(-1);
    },
  },

  created() {
    let wrapper = document.getElementById("wrapper");

    if (window.screen.width <= 768) {
      this.screen = "mobile";
    } else {
      this.screen = "desktop";
      this.open = true;
      wrapper ? (wrapper.style = "margin-left: 209px;") : "";
    }
  },

  mounted() {
    EventBus.$on("page-change", () => {
      this.mobileOpen = false;
    });
  },

  computed: {
    ...mapGetters({
      user: AUTH_USER_GET,
      challengeCategories: CATEGORIES_GET,
    }),

    getColor() {
      if (!this.$route.meta.layout) {
        if (this.user.subscription) {
          return "ocean";
        }
        return "orange";
      }
    },

    showOnPages() {
      if (
        this.$route.name === "challenges" ||
        this.$route.name === "challenges.browse" ||
        this.$route.name === "categories" ||
        this.$route.name === "categories.subcategories"
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
